import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'

export type BillingAddToGridState<R> = CrudModelPaginatorLaboratory<R>
export const initialBillingAddToGridState =
    <R>(): BillingAddToGridState<R> => ({
        ...initialCrudModelBaseState()
    })
